import { Expose, Type } from "class-transformer";
import { GeoJSONGeometry } from "ol/format/GeoJSON";

export const ApiResponseStatus = {
  BACKEND_ERROR: 'BACKEND_ERROR',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  ALREADY_CREATED: 'ALREADY_CREATED',
  NOT_FOUND_IN_DATABASE: 'NOT_FOUND_IN_DATABASE',
  NOT_CREATED: 'NOT_CREATED',
};

export class BulkUploadDTO {

  @Expose({ name: "owner_id" })
  public ownerId: string | null = null;
  
  @Expose({ name: "owner_name" })
  public ownerName: string | null = null;
  
  @Expose({ name: "farm_name" })
  public farmName: string | null = null;

  @Expose({ name: "car_code" })
  public carCode: string | null = null;

  @Expose({ name: "incra_allotment" })
  public incraAllotment: string | null = null;

  @Expose({ name: "crop_type_1" })
  public cropType1: string | null = null;
  
  @Expose({ name: "crop_type_2" })
  public cropType2: string | null = null;
  
  public geom: GeoJSONGeometry | null | string = null;
  public lat: number | null = null;
  public lng: number | null = null;  
  public analitica: boolean = false;
  public sentinela: boolean = false;

  public apiResponse?: BulkResponseDTO;

}

export class BulkResponseDTO {

  @Expose({ name: "owner_uuid" })
  public ownerUuid?: string;

  @Expose({ name: "ownerStatus" })
  public ownerStatus?: string;
  
  @Expose({ name: "farm_uuid" })
  public farmUuid?: string;
  
  @Expose({ name: "farm_status" })
  public farmStatus? : string;

  @Type(() => AnalysisResponseDTO)
  public analyses?: AnalysisResponseDTO[];

}

export class AnalysisResponseDTO {

  public uuid?: string;
  public status?: string;
  public type?: string;
  
  @Expose({ name: "crop_type" })
  public cropType? : string;

}
